import { COLOR_REQUEST, CREATE_COLOR, GET_COLOR, UPDATE_COLOR, DELETE_COLOR, 
COLOR_REQUEST_FAILURE, COLOR_REQUEST_SUCCESS, GET_COLOR_PAGE } from '../types';

const initialState = {
  colors: [],
  colorPage: [],
  loading: false,
  error: null,
};

const colorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case COLOR_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_COLOR: {
      return {
        ...state,
        colors: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_COLOR_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};      
      return {
        ...state,
        colorPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_COLOR:
      return {
        ...state,
        colors: [action.payload, ...state.colors],
        loading: false,
        error: null
      };
    case UPDATE_COLOR:
      const colorData = state.colors.slice(0);
      const uIndex = colorData.findIndex((data) => data.id === action.payload.id);
      colorData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        colors: [ ...colorData ],
        loading: false,
        error: null
      };
    case DELETE_COLOR:
      const color = state.colors?.slice(0);
      const index = color.findIndex((data) => data.id === action.id);
      if (index > -1) {
        color.splice(index, 1);
      }
      return {
        ...state,
        colors: [...color],
        loading: false,
        error: null
      }
    case COLOR_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case COLOR_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default colorsReducer;
